import { API } from '../../utils';
import { IParams } from '../types';
import { GW_SERVICES_PREFIXES } from 'constants/gateway';

const { C300 } = GW_SERVICES_PREFIXES;

/* Отчёт по домам */
export const GetHousesTaskReport = (params: IParams) =>
  API.get(`/${C300}/automation/houses_task_report/`, undefined, params);

/* Список задач опроса приборов */
export const GetMeterTaskReport = (params: IParams) =>
  API.get(`/${C300}/models/tasks/gprs/`, undefined, params);

/* Постановка задачи на опрос приборов */
export const PostMeterTaskReport = (data: IParams) =>
  API.gatewayPost(`/${C300}/forms/automation/tasks/`, data);

/* Статус опроса последних задач по счётчику */
export const GetLastTasks = (params: IParams) =>
  API.get(`/${C300}/forms/automation/last_tasks/`, undefined, params);

/* Получения списка котельных */
export const GetBoilers = () =>
  API.get(`/${C300}/boilers/settings_boilers/`);

/* Получения котельной по ID */
export const GetBoilersById = (params: IParams) =>
  API.get(`/${C300}/boilers/settings_boilers/`, undefined, params);

/* Создание котельной */
export const CreateBoilers = (params: IParams) =>
  API.gatewayPost(`/${C300}/boilers/settings_boilers/`, params);

/* Добавление или удаление дома из котельной */
export const ManageHouse = (id: string, params: IParams) =>
  API.gatewayPatch(`/${C300}/boilers/settings_boilers/`, id, params);

/* Обновление дома в котельной */
export const UpdateHouse = (houseId: string, params: IParams) =>
  API.gatewayPatch(`/${C300}/boilers/set_automation/`, houseId, params);

/* Обновление котельной */
export const PatchBoiler = (id: string, params: IParams) =>
  API.gatewayPatch(`/${C300}/boilers/update_graphs/`, id, params);

/* Отчет о теплопотреблении и "сырые" данные опроса приборов */
export const GetHeatReport = (params: IParams) =>
  API.get(`/${C300}/automation/heat_report/`, undefined, params);

/* Редактирование строки отчета */
export const EditLineHeatReport = (id: string, params: IParams) =>
  API.gatewayPatch(`/${C300}/automation/heat_report/`, id, params);

/* Расчёт строки отчёта по среднему */
export const AverageLineHeatReport = (id: string) =>
  API.gatewayPatch(`/${C300}/automation/auto_fill_row_average/`, id);

/* Расчёт строки отчёта по арифметическому */
export const ArithmeticLineHeatReport = (id: string) =>
  API.gatewayPatch(`/${C300}/automation/auto_fill_row_arithmetic/`, id);

/* Сдача отчета */
export const PostHeatReport = (data: IParams) =>
  API.gatewayPost(`/${C300}/automation/heat_report_submit/`, data);

/* Получение истории сформированных отчетов */
export const GetSubmitHeatReport = (params: IParams) =>
  API.get(
    `/${C300}/automation/heat_report_submit/`,
    undefined,
    params
  );

/* Получение последнего сданного отчета счетчика по его ID */
export const GetLastSubmitHeatReport = (meterId: string) =>
  API.get(`/${C300}/boilers/heat_report_submit/`, meterId);

/* Удаление сформированного отчета */
export const DeleteSubmitHeatReport = (id: string) =>
  API.delete(`/${C300}/automation/heat_report_submit/`, id);

/* Получение корректировки температуры */
export const GetTemperatureCorrection = (params: IParams) =>
  API.get(
    `/${C300}/automation/temperature_correction/`,
    undefined,
    params
  );

/* Установка корректировки температуры */
export const PostTemperatureCorrection = (data: IParams) =>
  API.gatewayPost(`/${C300}/automation/temperature_correction/`, data);

/* Получение номеров sim-карт */
export const GetAdapterSim = (params: IParams) =>
  API.get(`/${C300}/automation/adapter_sim/`, undefined, params);

/* Пересчёт данных отчета счетчика */
export const PostMeterRecalculate = (data: IParams) =>
  API.gatewayPost(`/${C300}/automation/meter_recalculate/`, data);

export const GetDefaultSettings = () =>
  API.get(`/${C300}/boilers/get_settings/default_mappings/`);

// Получение списка SIM провайдеров
export const GetSimProviders = () =>
  API.get(`/${C300}/sim/providers_sims/`);

// Создание SimCard
export const CreateSimCard = (params: IParams) =>
  API.gatewayPost(`/${C300}/sim/providers_sims/`, params);

// Обновление SimCard
export const UpdateSimCard = (id: string, params: IParams) =>
  API.gatewayPatch(`/${C300}/sim/change/provider_sim/`, id, params);

// Удаление SimCard
export const DeleteSimCard = (id: string) =>
  API.delete(`/${C300}/sim/change/provider_sim/`, id);

// Отчет о тепловых параметрах МКД
export const GetHeatHunter = (params: IParams) =>
  API.get(
    `/${C300}/automation/heat_hunter_report/`,
    undefined,
    params
  );

// Запись созданной заявки в отдельную коллекцию HeatReportRequests
export const CreateRequestReport = (data: IParams) =>
  API.gatewayPost(`/${C300}/automation/request_heat_hunter_report/`, data);

/* История тасок на опрос домовых счётчиков */
export const GetHeatHouseTasks = (params: IParams) =>
  API.get(`/${C300}/automation/heat_house_tasks/`, undefined, params);

/* Подробный лог конкретной таски на опрос */
export const GetTaskLog = (id: string) =>
  API.get(`/${C300}/automation/get_heat_log/`, id);

/* Отмена таски на опрос */
export const CancelTask = (id: string) =>
  API.gatewayPatch(`/${C300}/forms/automation/reset_task/`, id);
